import React from "react";


const App=({movie})=>{ 
    return(
        <>
      <div className='card__info'>
          <span className='card__category'>Title: {movie.title}</span> 
          <span className='card__category'>Overview: {movie.overview}</span> 
          <span className='card__category'>Rating: {movie.vote_average}</span> 
          <span className='card__category'>Release Date: {movie.release_date}</span> 
  </div>
        </>
    )
}

export default App;